import {
  Component,
  Inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material';
import {
  ActivatedRoute,
  Router,
} from '@angular/router';

import { Lightbox } from 'ngx-lightbox';
import { BehaviorSubject } from 'rxjs';
import { CommonService } from 'src/app/core/services/v2/common.service';
import { FormService } from 'src/app/core/services/v2/form.service';
import {
  InsuranceBenefitsComponent,
} from 'src/app/shared/components/insurance-benefits/insurance-benefits.component';
import {
  PreviewPdfComponent,
} from 'src/app/shared/components/preview-pdf/preview-pdf.component';
import {
  WindowLoaderService,
} from 'src/app/shared/components/window-loader/window-loader.service';

import { User } from '../../../core/model/user';
import {
  PatientContactPreferences,
} from '../../../core/models/patient/contactPreferences';
import {
  IAlbum,
  Patient,
} from '../../../core/models/patient/patient';
import { PatientAddress } from '../../../core/models/patient/patientAddress';
import { PatientChildren } from '../../../core/models/patient/patientChildren';
import {
  PatientInsuranceDetail,
} from '../../../core/models/patient/patientInsuranceDetail';
import { PatientService } from '../../../core/services/v2/patient.service';
import { PracticeService } from '../../../core/services/v2/practice.service';
import { UserService } from '../../../core/services/v2/user.service';
import {
  PreviewDocumentComponent,
} from '../../../shared/components/preview-document/preview-document.component';
import {
  PreviewImagesComponent,
} from '../../../shared/components/preview-images/preview-images.component';
import {
  GetValueForCodePipe,
} from '../../../shared/pipes/get-value-for-code.pipe';
import { Practitioner } from '../../profile/models/practitioner';
import {
  PhysicianOptionService,
} from '../../shared/physician-option/physician-option.service';
import {
  PatientAppointmentsListComponent,
} from '../patient-appointments-list/patient-appointments-list.component';
import {
  PatientReferalListComponent,
} from '../patient-referal-list/patient-referal-list.component';
import {
  PhysicianPatientSidebarComponent,
} from '../physician-patient-sidebar/physician-patient-sidebar.component';
import {
  PatientInsuranceDialogComponent,
} from './patient-insurance-dialog/patient-insurance-dialog.component';

@Component({
  selector: "app-physician-patient-profile",
  templateUrl: "./physician-patient-profile.component.html",
  styleUrls: ["./physician-patient-profile.component.scss"],
})
export class PhysicianPatientProfileComponent implements OnInit {
  @Input() patientDetails: Patient;
  @Input() openSection: string;
  toggleSidebar = false;
  isConsentForm: boolean = false;
  practitioner$: BehaviorSubject<Practitioner> = new BehaviorSubject(null);
  practitionerId = 0;
  photoUrlsend: string;
  selectedIndex = 0;
  selectedFile = null;
  sideBarHeader: string;
  patientProfile: Patient;
  isDialog = false;
  user: User;
  canBeRefferred = false;

  isParams = false;
  param: number;

  sectionName: string;

  mobilePhoneNumber: PatientContactPreferences;
  workPhoneNumber: PatientContactPreferences;
  homePhoneNumber: PatientContactPreferences;
  emailAddress: PatientContactPreferences;

  //from address
  homeAddress: PatientAddress;
  previousAddress: PatientAddress;
  mailAddress: PatientAddress;
  billingAddress: PatientAddress;

  billAddressSameAsMailing = false;
  billAddressSameAsHome = false;
  mailAddressSameAsHome = false;

  //from guardianship
  guardianshipLatter;
  poaLetter;

  previewTitle: string;
  previewFrontUrl: string;
  previewBackUrl: string;
  formList: any = [];

  patientInsurance: PatientInsuranceDetail[];

  @ViewChild(PhysicianPatientSidebarComponent, { static: false })
  childComponent: PhysicianPatientSidebarComponent;
  constructor(
    private patientService: PatientService,
    private practiceService: PracticeService,
    private userService: UserService,
    private formService: FormService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private lightbox: Lightbox,
    private codePipe: GetValueForCodePipe,
    private loaderService: WindowLoaderService,
    private physicianOptionService: PhysicianOptionService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    if (!this.openSection) {
      this.openSection = 'profile';
    }

    this.commonService.getItemCodesFiltered("GENDER");
    const filterPipe = new GetValueForCodePipe(this.commonService);
    const fiteredArr = filterPipe.transform("", "LANGUAGE");
    this.param = this.patientDetails.id;
    if (this.patientDetails.id) {
      //this.getPatientDetailsById(this.param);
    } else {
      this.getPatientDetailsByUserId();
    }

    //   this.loaderService.show();
    //   this.userService.getMe().subscribe(
    //     (res) => {
    //       this.user = res;
    //       this.loaderService.hide();
    //       if (this.isParams) {
    //         this.getPatientDetailsById(this.param);
    //       } else {
    //         this.getPatientDetailsByUserId();
    //       }
    //     },
    //     (error) => { console.error(error); this.loaderService.hide(); }
    //   );
  }

  getPatientDetailsById(id) {
    const self = this;
    this.loaderService.show();
    this.patientService.getPatientDetailsById(id).subscribe(
      (details) => {
        self.patientProfile = null;
        self.patientProfile = details;
        self.patientProfile.photoUrl = self.patientProfile.photoUrl
          ? (self.patientProfile.photoUrl += "?" + Math.random())
          : self.patientProfile.photoUrl;
        self.populatePhoneNumbers();
        self.populateAddresses();
        this.practiceService
          .patientCanBeReffered(
            self.physicianOptionService.getPhysician().id,
            self.patientProfile.id
          )
          .subscribe(
            (res) => {
              //console.log('canBe', res);
              if (res["isSuccess"]) {
                self.patientProfile.canBeRefferred = res["message"];
              }
              this.loaderService.hide();
            },
            (error) => {
              console.error(error);
              this.loaderService.hide();
            }
          );
        this.loaderService.hide();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      }
    );
  }
  getPatientDetailsByUserId() {
    var self = this;
    this.loaderService.show();
    this.loaderService
      .blockWithLoader(this.patientService.getCurrentPatientDetails())
      .subscribe(
        (details) => {
          self.patientProfile = null;
          self.patientProfile = details;
          self.patientProfile.photoUrl = self.patientProfile.photoUrl
            ? (self.patientProfile.photoUrl += "?" + Math.random())
            : self.patientProfile.photoUrl;
          self.populatePhoneNumbers();
          self.populateAddresses();
          this.loaderService.hide();
        },
        (error) => {
          console.error(error);
        }
      );
  }
  showHideScroll(isOpen: boolean) {
    /* To stop body scroll while sidebar is Open */
    const body = document.querySelector("body");
    if (isOpen) {
      body.style.cssText = "height:100vh; overflow:hidden";
    } else {
      body.style.cssText = "height:auto; overflow:visible";
    }
  }
  setSidebarHeader(sectionName: string) {
    switch (sectionName) {
      case "family":
        this.isConsentForm = false;
        this.sideBarHeader = "Family";
        break;
      case "directives":
        this.isConsentForm = false;
        this.sideBarHeader = "Directives";
        break;
      case "pharmacies":
        this.isConsentForm = false;
        this.sideBarHeader = "Pharmacy Preferences";
        break;
      case "consentForms":
        this.sideBarHeader = "Consent Forms";
        this.getFormsByPatientId();
        break;
      case "referPatient":
        this.isConsentForm = false;
        this.sideBarHeader = "Refer Patient";
        break;
      default:
        this.isConsentForm = false;
        this.sideBarHeader = "Patient Details";
    }
  }

  getFormsByPatientId() {
    this.patientService.isConsentForm = true;
    this.formService.getPdfFormsByPatientId(this.param).subscribe((res) => {
      this.isConsentForm = true;
      this.formList = res[0].appointmentAssignedForms;
    });
  }

  openFormPDFPreview(form) {
    this.dialog.open(PreviewPdfComponent, {
      width: "80%",
      maxWidth: "95%",
      hasBackdrop: true,
      disableClose: true,
      data: form,
    });
  }

  toggleEditSidebar(sectionName: string) {
    this.setSidebarHeader(sectionName);
    this.sectionName = sectionName;
    this.toggleSidebar = !this.toggleSidebar;
    this.showHideScroll(this.toggleSidebar);
    this.destroyChild();
  }
  togglePopUp(patientProfile: Patient) {
    this.patientProfile = patientProfile;
    this.toggleSidebar = !this.toggleSidebar;
    this.showHideScroll(this.toggleSidebar);
    this.destroyChild();
  }

  destroyChild() {
    this.childComponent.ngOnDestroy();
  }

  populatePhoneNumbers() {
    if (!this.patientProfile || !this.patientProfile.patientContactPreferences)
      return false;

    this.patientProfile.patientContactPreferences.forEach((value) => {
      if (value.contactType == "HOMENUMBER") {
        if (value.active) this.homePhoneNumber = value;
      } else if (value.contactType == "WORKNUMBER") {
        if (value.active) this.workPhoneNumber = value;
      } else if (value.contactType == "MOBILENUMBER") {
        if (value.active) this.mobilePhoneNumber = value;
      } else if (value.contactType == "EMAIL")
        if (value.active) this.emailAddress = value;
    });

    return true;
  }
  populateAddresses() {
    if (!this.patientProfile || !this.patientProfile.addresses) return false;
    this.patientProfile.addresses.forEach((value) => {
      if (value.type == "HOME") {
        if (value.active) {
          this.homeAddress = value;

          if (value.isMailing) {
            this.mailAddressSameAsHome = true;
            this.mailAddress = { ...this.homeAddress };
          }

          if (value.isBilling) {
            this.billAddressSameAsHome = true;
            this.billAddressSameAsMailing = false;
            this.billingAddress = { ...this.homeAddress };
          }
        } else if (!value.active) this.previousAddress = value;
      } else if (value.type == "MAILING") {
        this.mailAddress = value;
        if (value.isBilling) {
          this.billAddressSameAsMailing = true;
          this.billingAddress = { ...this.mailAddress };
        }
      } else if (value.type == "BILLING") this.billingAddress = value;
    });

    return true;
  }

  billingSameAsHomeAddress(change: boolean) {
    this.billAddressSameAsHome = change;
    this.billAddressSameAsMailing = false;
    this.billingAddress = { ...this.homeAddress };
  }

  billingSameAsMailingAddress(change: boolean) {
    this.billAddressSameAsHome = false;
    this.billAddressSameAsMailing = change;
    this.billingAddress = { ...this.mailAddress };
  }

  mailSameAsHomeAddress(change: boolean) {
    this.mailAddressSameAsHome = change;
    if (this.mailAddressSameAsHome) this.mailAddress = { ...this.homeAddress };

    if (this.billAddressSameAsMailing)
      this.billingAddress = { ...this.mailAddress };
  }

  filterAddressOfType(type) {
    return this.patientProfile.addresses.filter((x) => x.type === type);
  }

  onFileSelectedG(event, child: PatientChildren) {
    this.guardianshipLatter = event.target.files[0];
  }
  onFileSelectedP(event, child: PatientChildren) {
    this.poaLetter = event.target.files[0];
  }

  checkExt(filename) {
    return filename.split(".").pop();
  }

  openLightbox(url): void {
    const album: IAlbum[] = [{ src: url, thumb: url }];
    this.lightbox.open(album, 0);
  }
  copyMessage(val: string) {
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
  }
  setCardPreviewValues(title, front, back) {
    this.previewTitle = title;
    this.previewFrontUrl = front;
    this.previewBackUrl = back;
    return true;
  }
  previewDocument(title: string, location: any, code: string) {
    if (title && code) title = this.codePipe.transform(title, code);

    const dialogRef =
      typeof location == "string" && this.checkExt(location) == "pdf"
        ? this.dialog.open(PreviewDocumentComponent, {
            id: "previewDocument",
            maxWidth: "80%",
            panelClass: "preview-modal",
            disableClose: true,
            backdropClass: "preview-modal",
            data: { documentTitle: title, documentLocation: location },
          })
        : this.dialog.open(PreviewImagesComponent, {
            id: "previewDocument",
            width: "80%",
            disableClose: true,
            data: {
              documentTitle: title,
              images: location,
            },
          });
  }
  openReferralHistory() {
    this.dialog.open(PatientReferalListComponent, {
      id: "patientreferrals",
      width: "95%",
      maxWidth: "95%",
      hasBackdrop: true,
      disableClose: true,
      data: {
        patientData: this.patientProfile,
      },
    });
  }
  openAppointmentHistory() {
    this.dialog.open(PatientAppointmentsListComponent, {
      id: "patientreappointments",
      width: "95%",
      maxWidth: "95%",
      hasBackdrop: true,
      disableClose: true,
      data: {
        patientData: this.patientProfile,
      },
    });
  }
  openInsuranceBenefits() {
    const dialogRef = this.dialog.open(InsuranceBenefitsComponent, {
      id: "insuranceBenefits",
      width: "80%",
      disableClose: true,
      data: {
        documentTitle: "Benefits",
        patient: this.patientProfile,
      },
    });
  }
  makeAppointment() {
    console.log(this.patientProfile);
    if (this.patientProfile) {
      localStorage.setItem(
        "patientSelected",
        JSON.stringify(this.patientProfile)
      );
      this.router.navigate(["physician/appointments"]);
    }
  }
  openpatientInsuranceDialog() {
    const dialogRef = this.dialog.open(PatientInsuranceDialogComponent, {
      maxWidth: "90vw",
      maxHeight: "90vh",
      height: "90%",
      width: "90%",
      id: "dialogInsurance",
      data: {
        patient: this.patientProfile,
        physiciannpi: this.physicianOptionService.getPhysician().npi,
      },
    });

    console.log(this.patientProfile);
  }
}
